import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateCurrentPlatformMutation } from "../graphql/mutations";
import type {
  UpdateCurrentPlatformMutationType,
  UpdateCurrentPlatformMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateCurrentPlatformMutation = (
  options?: MutationHookOptions<
    UpdateCurrentPlatformMutationType,
    UpdateCurrentPlatformMutationVariablesType
  >
) => {
  return useMutation<
    UpdateCurrentPlatformMutationType,
    UpdateCurrentPlatformMutationVariablesType
  >(UpdateCurrentPlatformMutation, options);
};
